<template>
  <div style="margin: 10px; height: 600px">
    <v-form direction="horizontal">
      <div style="text-align: left">
        <v-affix :offset-top="10">
          <v-button type="success" icon="save" @click.prevent="save()"
            >保存</v-button
          >
        </v-affix>
      </div>
      <v-form-item
        label="公告标题"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
        required
      >
        <v-input
          v-model="options.bt"
          placeholder="公告标题"
        ></v-input>
      </v-form-item>
      <v-form-item
        label="公告内容"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
        required
      >
        <v-input v-model="options.nr" type="textarea" placeholder="公告内容"></v-input>
      </v-form-item>
      <v-form-item
        label="截止日期"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
        required
      >
        <v-date-picker
          style="width: 100%"
          v-model="options.jzrq"
          clearable
          size="lg"
          format="yyyy-MM-dd"
        ></v-date-picker>
      </v-form-item>
      <v-form-item
        label="启用"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
      >
        <v-switch v-model="options.yxbz"></v-switch>
      </v-form-item>
    </v-form>
  </div>
</template>

<script>
let options = {
  id:"",
  bt: "",
  nr: "",
  jzrq:"",
  yxbz: true,
};
export default {
  data() {
    return {
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 14,
      },
      options
    };
  },
  created() {
    if (this.$route.query.id) {
      this.options.id = this.$route.query.id;
      this.init();
    }
  },
  methods: {
    init: function () {
      this.$axios
        .get("api/system/ggfb/get-ggfb-first?id=" + this.$route.query.id)
        .then((res) => {
          this.options = res.data;
          this.options.id = this.$route.query.id;
          if (res.data.yxbz == 1) {
            this.options.yxbz = true;
          } else {
            this.options.yxbz = false;
          }
        });
    },
    save() {
      if(!this.options.bt){
        this.$message["error"]("请输入公告标题");
        return;
      }
      if(!this.options.nr){
        this.$message["error"]("请输入公告内容");
        return;
      }
      if(!this.options.jzrq){
        this.$message["error"]("请选择截止日期");
        return;
      }
      if (this.options.yxbz) {
        this.options.yxbz = "1";
      } else {
        this.options.yxbz = "0";
      }
      if (this.$route.query.id) {
        this.$axios
          .post("api/system/ggfb/update-ggfb-first", this.options)
          .then((res) => {
            if (res.data.code == 200) {
              this.$message["success"](res.data.message);
              xadmin.close();
              xadmin.father_reload();
            } else {
              this.$message["error"](res.data.message);
            }
          });
      } else {
        this.$axios
          .post("api/system/ggfb/set-ggfb-first", this.options)
          .then((res) => {
            if (res.data.code == 200) {
              this.$message["success"](res.data.message);
              xadmin.close();
              xadmin.father_reload();
            } else {
              this.$message["error"](res.data.message);
            }
          });
      }
    },
    cancel: function () {
      xadmin.close();
    },
  },
};
</script>


<style>
</style>


// WEBPACK FOOTER //
// src/view/xtgl/jcsj/ggfbadd.vue